import { render, staticRenderFns } from "./ElementNameTableColumn.vue?vue&type=template&id=5089d156&scoped=true"
import script from "./ElementNameTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementNameTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementNameTableColumn.vue?vue&type=style&index=0&id=5089d156&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5089d156",
  null
  
)

export default component.exports